import styled from "@emotion/styled";
import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
import { sizes } from "../../../constants/spacing";
import { TypeRampV2 } from "../../typography";
import { labelStyles } from "./FormLabelLabel";
const descriptionStyles = themed({
  color: color("color--text--neutral--weak"),
  marginTop: {
    default: {
      "lodestar-light": sizes.xxSmall,
      "ursa-light": 0
    },
    afterLabel: {
      "lodestar-light": sizes.xxSmall,
      "ursa-light": 3
    }
  }
});
export const FormLabelDescription = styled(TypeRampV2)`
    color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return descriptionStyles.color(themeMode);
}};
    &:not(:empty) {
        margin-bottom: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return labelStyles.margin(themeMode);
}}px;
        margin-top: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return descriptionStyles.marginTop.default(themeMode);
}}px;
        label + & {
            margin-top: -${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return descriptionStyles.marginTop.afterLabel(themeMode);
}}px;
        }
    }
`;
//# sourceMappingURL=FormLabelDescription.js.map